(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__(1);

var _stringify2 = _interopRequireDefault(_stringify);

var _jss = __webpack_require__(2);

var _jss2 = _interopRequireDefault(_jss);

var _v = __webpack_require__(3);

var _v2 = _interopRequireDefault(_v);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fontType = {
  eot: 0,
  woff: 1,
  ttf: 2,
  svg: 3
};

var createUrl = function createUrl(_ref) {
  var url = _ref.url,
      hash = _ref.hash,
      format = _ref.format,
      _ref$afterHash = _ref.afterHash,
      afterHash = _ref$afterHash === undefined ? '' : _ref$afterHash;
  return 'url("' + url + (hash ? '?' + hash : '') + afterHash + '")' + (format ? ' format("' + format + '")' : '');
};

var createUrlParamters = function createUrlParamters(_ref2) {
  var type = _ref2.type,
      url = _ref2.url,
      hash = _ref2.hash;

  var format = void 0;
  var afterHash = void 0;

  switch (type) {
    case fontType.eot:
      {
        format = 'embedded-opentype';
        afterHash = '?#iefix';
        break;
      }
    case fontType.woff:
      {
        format = 'woff';
        break;
      }
    case fontType.ttf:
      {
        format = 'truetype';
        break;
      }
    case fontType.svg:
      {
        format = 'svg';
        afterHash = '#font-loader';
        break;
      }
    default:
      return undefined;
  }

  return {
    url: url,
    hash: hash,
    format: format,
    afterHash: afterHash
  };
};

var getUrl = function getUrl(param) {
  return createUrl(createUrlParamters(param));
};

var createFontFamily = function createFontFamily(_ref3) {
  var eot = _ref3.eot,
      woff = _ref3.woff,
      ttf = _ref3.ttf,
      svg = _ref3.svg,
      hash = _ref3.hash;

  var fontName = 'font-' + (0, _v2.default)();

  _jss2.default.createStyleSheet({
    '@font-face': {
      'font-family': (0, _stringify2.default)(fontName),
      src: [{
        url: eot,
        type: fontType.eot
      }, {
        url: woff,
        type: fontType.woff
      }, {
        url: ttf,
        type: fontType.ttf
      }, {
        url: svg,
        type: fontType.svg
      }].filter(function (_ref4) {
        var url = _ref4.url;
        return url !== undefined;
      }).map(function (_ref5) {
        var url = _ref5.url,
            type = _ref5.type;
        return getUrl({ url: url, type: type, hash: hash });
      }).join(', ')
    }
  }).attach();

  return fontName;
};

module.exports = createFontFamily;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("babel-runtime/core-js/json/stringify");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("jss");

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("uuid/v4");

/***/ })
/******/ ]);
});
//# sourceMappingURL=create-font-family.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ttf-loader/lib/create-font-family.js
// module id = 490
// module chunks = 0